import styled from '@emotion/native';

export const SummaryWrapper = styled.View({
  flexDirection: 'row',
  justifyContent: 'space-between',
});
